<template>
  <div class="vb-checkout">
    <router-link :to="{ name: 'quote' }">
      <span class="vb-detail__back">indietro</span>
    </router-link>
    <h1 class="vb-heading h2 mt-3">I dettagli della tua prenotazione</h1>
    <p v-if="is_flight_and_stay_package">Verifica con attenzione i dettagli del pacchetto che stai prenotando.</p>
    <p v-else>Verifica con attenzione i dettagli del soggiorno che stai prenotando.</p>
    <pratica :services="quote.services" :passengers="passengers.passengers" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pratica from "@alpitour/components/blocks/pratica.vue";
export default {
  name: "checkout-block",
  props: {
    selected_room: {},
    quote: {},
    passengers: [],
  },
  components: {
    pratica: Pratica,
  },
  computed: {
    ...mapGetters("liveat", ["is_flight_and_stay_package"]),
  },
};
</script>
